export default function HunterReward(props) {

  const handleChange = (event) => {
    props.setBountyState({ type: 'add_reward', recipient: 'hunter', amount: event.target.value })
  }

  return (
    <div className="mb-3">
      <label htmlFor="hunterReward" className="form-label">Hunter Reward</label>
      <input onChange={handleChange} value={props.reward} type="number" className="form-control" id="hunterReward" />
    </div>
  )
}
